import React from "react";
import { X, CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Switch } from "@/components/ui/switch";
import Divider from "@/components/shared/Divider/Divider.tsx";

interface SecretOrderBumpInfoSheetProps {
  isEnabled: boolean;
  onToggle: (checked: boolean) => void;
  onClose: () => void;
  isSubmitting?: boolean;
}

export function SecretOrderBumpInfoSheet({
  isEnabled,
  onToggle,
  onClose,
  isSubmitting = false,
}: SecretOrderBumpInfoSheetProps) {
  const { t } = useTranslation("orderBumps");

  return (
    <section className="sm:overflow-y-hidden h-full flex flex-col justify-between">
      <SheetHeader className="p-6">
        <SheetTitle className="flex gap-2">
          {t("secret_order_bump_title")}
        </SheetTitle>
      </SheetHeader>

      <div className="flex-1 px-6 pb-12 overflow-y-auto">
        <p className="text-sm text-zinc-400 mb-6">
          {t("secret_order_bump_description")}
        </p>

        <div className="flex items-center gap-2 mb-8">
          <Switch checked={isEnabled} onCheckedChange={onToggle} />
          <span className="text-sm text-zinc-100">
            {t("activate_secret_order_bump")}
          </span>
        </div>
        <Divider />
        <div className="space-y-6 mt-5">
          <h3 className="text-lg font-medium text-zinc-100">
            {t("advantages.title")}
          </h3>

          <div className="space-y-4">
            {[
              "conversion_increase",
              "distraction_reduction",
              "average_ticket_increase",
              "fluid_experience",
            ].map((advantage) => (
              <div key={advantage} className="flex gap-3">
                <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#1A1A1A] flex items-center justify-center">
                  <CheckCircle size={16} className="text-primary" />
                </div>
                <div className="space-y-1">
                  <h4 className="text-sm font-medium text-zinc-100">
                    {t(`advantages.${advantage}.title`)}
                  </h4>
                  <p className="text-sm text-zinc-400">
                    {t(`advantages.${advantage}.description`)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
